<div class="fuse-drawer-content" [ngClass]="[width, minWidth, maxWidth]">
    <ng-content></ng-content>
</div>
